import React from 'react';
import Link from '../../lib/router/Link';
import router from '../../lib/router/router';

function getEpisodeRoutePath(id: string, slug: string): string {
  return `/episode/${id}/${slug}`;
}

function navigateToEpisodePage(id: string, slug: string) {
  router.pushState(getEpisodeRoutePath(id, slug));
}

function EpisodeLink({ id, slug, onClick, children }) {
  return (
    <Link href={getEpisodeRoutePath(id, slug)} onClick={onClick}>
      {children}
    </Link>
  );
}

export { getEpisodeRoutePath, navigateToEpisodePage };

export default EpisodeLink;
